function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconArrowLeftSmallOutline = function IconArrowLeftSmallOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.575 5.955l1.158-1.171a1.054 1.054 0 000-1.478 1.024 1.024 0 00-1.46 0L.623 7l3.65 3.694a1.024 1.024 0 001.46 0 1.054 1.054 0 000-1.478L4.575 8.045h7.015c.57 0 1.033-.468 1.033-1.045s-.463-1.045-1.033-1.045H4.575z",
    clipRule: "evenodd"
  }));
};

export default IconArrowLeftSmallOutline;